import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';
import {
  NotificationsProvider,
  useNotifyFactory,
} from 'app/common/notifications/features/notifications';
import { PageContent } from 'app/ui';

import { DetailsTerminal } from '../features/details-terminal';

export const DetailsTerminalPage = observer(() => {
  const notify = useNotifyFactory();

  return (
    <NotificationsProvider value={notify}>
      <AppPage perm="PERM_TERMINAL_READ">
        <PageContent>
          <DetailsTerminal />
        </PageContent>
      </AppPage>
    </NotificationsProvider>
  );
});
